
import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/interfaces/category.model';

@Component({
    selector: 'app-menu-categories',
    templateUrl: './menu-categories.component.html',
    styleUrls: ['./menu-categories.component.css'],
    standalone: false
})
export class MenuCategoriesComponent implements OnInit {
  cdr: any;
  constructor(
    private categoryService: CategoryService, 
  ) {}

  @ViewChild('categoriesNavigation') categoriesNavigation!: ElementRef;
  
  sortedCategories: Category[] = [];
  logoHeight: number = 0;
  toolbarOpacity = 0;

  ngOnInit(): void {
    this.categoryService.categories$.subscribe(list => {
      if (list) {
        this.sortedCategories = list.slice().sort((a, b) => a.index - b.index);
      } else {
        this.sortedCategories = [];
      }
    });
  }
}
